import { FC, ComponentType } from 'react'
import clsx from 'clsx'

interface DashboardCardProps {
  title: string
  value: string | number
  icon: ComponentType<{ className?: string }>
  iconColor?: string
  bgColor?: string
  valueClass?: string
  trend?: {
    value: number
    isPositive: boolean
  }
  className?: string
}

const DashboardCard: FC<DashboardCardProps> = ({
  title,
  value,
  icon: Icon,
  iconColor = 'text-gray-600',
  bgColor = 'bg-gray-50',
  valueClass = '',
  trend,
  className = ''
}) => {
  return (
    <div className={clsx('card p-6', className)}>
      <div className="flex items-center">
        <div className={clsx('p-3 rounded-lg', bgColor)}>
          <Icon className={clsx('w-6 h-6', iconColor)} />
        </div>
        <div className="ml-4 flex-1">
          <p className="text-sm font-medium text-gray-600">{title}</p>
          <div className="flex items-baseline">
            <p className={clsx('text-2xl font-semibold text-gray-900', valueClass)}>
              {value}
            </p>
            {trend && (
              <span
                className={clsx(
                  'ml-2 text-sm font-medium',
                  trend.isPositive ? 'text-success-600' : 'text-danger-600'
                )}
              >
                {trend.isPositive ? '+' : ''}{trend.value}%
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DashboardCard
